var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReseller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffabd9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1139.667 -786.778)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1147.667,786.778a8,8,0,1,0,8,8A8,8,0,0,0,1147.667,786.778Zm0,14.273a6.273,6.273,0,1,1,6.273-6.273A6.281,6.281,0,0,1,1147.667,801.051Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1176.631,819.155a4.587,4.587,0,1,0,4.587,4.587A4.592,4.592,0,0,0,1176.631,819.155Zm0,7.173a2.586,2.586,0,1,1,2.586-2.586A2.589,2.589,0,0,1,1176.631,826.328Z",
    transform: "translate(-28.964 -28.964)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReseller);
export default __webpack_public_path__ + "static/media/reseller.edcba2bb7de4330ead36f0d855df7d24.svg";
export { ForwardRef as ReactComponent };